export default "__VITE_ASSET__qpsF0Cvm__"